export const SNACKBAR_COLOR = {
    success: 'success',
    error: 'error',
    info: 'info'
}

export const LETTER_FORMAT = {
    UPPERCASE: 'uppercase',
    UPTITLECASE: 'up title case',
    UPFIRSTCASE: 'up first case'
}